import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { SupervisorState } from "./types";
import { RootState } from "@/store/types";

const supervisor: Module<SupervisorState, RootState> = {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};

export default supervisor;
